function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-d3491394\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./SweetModal.vue")
}
var normalizeComponent = require("!../../../vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./SweetModal.vue"
import __vue_script__ from "!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./SweetModal.vue"
/* template */
import __vue_template__ from "!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d3491394\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../vue-loader/lib/selector?type=template&index=0!./SweetModal.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/sweet-modal-vue/src/components/SweetModal.vue
// module id = YfoY
// module chunks = 1